module.exports = ".mat-menu-item {\n  height: inherit;\n  width: inherit;\n  background: transparent;\n}\n\n"